module.exports = __webpack_public_path__ + "img/2.4e9e1fca.png";